import './LoadingScreen.css'
import React from 'react'

const loadingScreen = () => {
  return (
    <div className='LoadingScreen inter'>
        <img src='/assets/black_logo_with_text_edit.png' alt='Loading screen'></img>
        <p>Welcome to the future of client service.</p>
        <p>Welcome to Futur-e Insurance Brokers.</p>
    </div>
  )
}

export default loadingScreen